import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Table from "react-bootstrap/Table";
import Preloader from "../../../shared/PreLoaders";

const DivisionShgMemberPage = () => {
  const { divisionId } = useParams();
  const [vfcList, setVfcList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // 'all' or 'range'
  const [expandedRanges, setExpandedRanges] = useState([]);
  const [selectedRangeId, setselectedRangeId] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [summary, setSummary] = useState({});
  const Api = process.env.REACT_APP_API;

  const LOCAL_KEY = `divisionSHGMemberDataCache_${divisionId}`;

  const saveToLocalCache = (vfcList, summary) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcList, summary, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVfcData = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(
        `${Api}/api/drill/shg/by-division-shg/${divisionId}`,
        config
      );
      setVfcList(res.data.data);
      saveToLocalCache(res.data.data, res.data.summary);
      setSummary(res.data.summary);
    } catch (error) {
      console.error("Failed to load VFCs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcList) {
      setVfcList(cached.vfcList);
      setSummary(cached.summary || {}); // defensive
      setLoading(false);
    } else {
      fetchVfcData();
    }
  }, [divisionId]);

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };

  const toggleRangeExpand = (rangeId) => {
    setExpandedRanges((prev) =>
      prev.includes(rangeId)
        ? prev.filter((id) => id !== rangeId)
        : [...prev, rangeId]
    );
  };

  if (loading) return <Preloader loading={true} />;
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchVfcData();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>
      <div className="card bg-gradient-success card-img-holder text-white">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />

          <h4 className="font-weight-normal mb-3">
            {" "}
            {vfcList.length > 0 ? vfcList[0].divisionName : "Loading..."}{" "}
            Division
          </h4>

          <h3>
            SHG Member's -{" "}
            {(summary?.totalDivisionMembers || 0).toLocaleString("en-IN")}
          </h3>
        </div>
      </div>
      <div className="mt-4">
        <button
          className={`btn btn-outline-success m-1 ${
            selectedOption === "all" ? "active" : ""
          }`}
          onClick={() => setSelectedOption("all")}
        >
          All Ranges
        </button>

        {selectedOption === "range" && (
          <div className="mt-3">
            {vfcList
              .sort((a, b) => a.rangeName.localeCompare(b.rangeName))
              .map((range) => (
                <button
                  key={range.rangeId}
                  className={`btn btn-outline-success m-1 ${
                    selectedRangeId === range.rangeId ? "active" : ""
                  }`}
                  onClick={() => {
                    setselectedRangeId(range.rangeId);
                    if (selectedRangeId === "range") {
                      setExpandedRanges({ [range.rangeId]: true });
                    }
                  }}
                >
                  {range.rangeName}
                </button>
              ))}
          </div>
        )}

        {selectedOption === "all" && (
          <div className="mt-4">
            {[...vfcList]
              .sort((a, b) => a.rangeName.localeCompare(b.rangeName))
              .map((range) => (
                <div key={range.rangeId} className="mt-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      background: "white",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                    onClick={() => toggleRangeExpand(range.rangeId)}
                  >
                    <h5 className="mb-0"> {range.rangeName}</h5>
                    <span style={{ fontSize: "1.2rem" }}>
                      {expandedRanges.includes(range.rangeId) ? "−" : "+"}
                    </span>
                  </div>

                  {expandedRanges.includes(range.rangeId) && (
                    <Table striped bordered hover className="mt-2">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Circle Name</th>
                          <th>Division Name</th>
                          <th>Range Name</th>
                          <th className="text-center">SHG's</th>
                          <th className="text-center">Total Members</th>
                          <th className="text-center">Male</th>
                          <th className="text-center">Female</th>
                          <th className="text-center">Third Gender</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>{range.circleName}</td>
                          <td>{range.divisionName}</td>
                          <td
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate(
                                `/drill/range-Shg-members/${range.rangeId}`
                              )
                            }
                          >
                            {range.rangeName}
                          </td>
                          <td className="text-center">{range.shgCount}</td>
                          <td className="text-center">
                            {range.totalMembers.toLocaleString("en-IN")}
                          </td>
                          <td className="text-center">
                            {range.maleCount.toLocaleString("en-IN")}
                          </td>
                          <td className="text-center">
                            {range.femaleCount.toLocaleString("en-IN")}
                          </td>
                          <td className="text-center">
                            {range.otherCount.toLocaleString("en-IN")}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DivisionShgMemberPage;
